import { guidEmpty } from "utils/guid-empty";
import { ImportacaoArquivoModel } from "./importacao-arquivo-model";

export class ImportacaoArquivoPostModel{
    constructor(
        public list: ImportacaoArquivoModel[] = [],
        public empresaId: string = guidEmpty(),
    ) {}
}